<template>
  <div :class="data.class" class="time-block">
    {{ time }}
  </div>
</template>

<script>
export default {
  name: 'timeblock',
  props: ['data'],
  computed: {
    time() {
      return this.moment().format('DD. MMMM YYYY, HH:mm [Uhr]')
    }
  }
}
</script>



// WEBPACK FOOTER //
// BlockTime.vue?75efcdb8